import { action, ActionType } from "typesafe-actions";
import { FlyerDetailPageEditType } from "../types/flyer-detail-page-state/flyer-detail-page-state.interface";
import { IFlyerDetailPage } from "../../../../../types/flyer-detail-data/flyer-detail-page/flyer-detail-page.interface";
import { IError } from "../../../../../../../redux/actions/errorHandlingAction";
import { Language } from "../../../../../../../types/language.type";
import { FlyerTemplate } from "../../../../../features/flyer-template/types/flyer-template/flyer-template.interface";
import { FlyerDetailPagePreview } from "../types/flyer-detail-page-preview/flyer-detail-page-preview.interface";
import { IFlyerDetailPagePosition } from "../../../../../types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.interface";
import { FlyerDetailPageFormPositionActionType } from "../features/flyer-detail-page-form-position/store/flyer-detail-page-form-position.actions";
import { FlyerDetailPageFormPageActionType } from "../features/flyer-detail-page-form-page/store/flyer-detail-page-form-page.actions";
import { FlyerDetailPageAssetsActionType } from "../features/flyer-detail-page-assets/store/flyer-detail-page-assets.actions";

export enum FlyerDetailPageActions {
  FetchPagePreview = "FlyerDetailPage/FetchPreview",
  FetchPagePreviewSuccess = "FlyerDetailPage/FetchPreviewSuccess",
  FetchPagePreviewFailure = "FlyerDetailPage/FetchPagePreviewFailure",

  CreatePagePosition = "FlyerDetailPage/CreatePagePosition",
  CreatePagePositionSuccess = "FlyerDetailPage/CreatePagePositionSuccess",
  CreatePagePositionFailure = "FlyerDetailPage/CreatePagePositionFailure",

  SetEditPagePositionId = "FlyerDetailPage/SetEditPagePositionId",

  DeSelectPosition = "FlyerDetailPage/DeSelectPosition",

  FetchPageTemplate = "FlyerDetailPage/FetchPageTemplate",
  FetchPageTemplateSuccess = "FlyerDetailPage/FetchPageTemplateSuccess",
  FetchPageTemplateFailure = "FlyerDetailPage/FetchPageTemplateFailure",

  SelectLanguage = "FlyerDetailPage/SelectLanguage",
  SetEditType = "FlyerDetailPage/SetEditType",

  UpdatePage = "FlyerDetailPage/UpdatePage",

  ResetEditType = "FlyerDetailPage/ResetEditType",
  NavigateToFlyerPages = "FlyerDetailPage/NavigateToFlyerPages",

  InitPermissions = "FlyerDetailPage/InitPermissions",

  Reset = "FlyerDetailPage/Reset",
}

export const fetchPagePreview = (pageId: number) =>
  action(FlyerDetailPageActions.FetchPagePreview, pageId);
export const fetchPagePreviewSuccess = (preview: FlyerDetailPagePreview) =>
  action(FlyerDetailPageActions.FetchPagePreviewSuccess, preview);
export const fetchPagePreviewFailure = (error: IError) =>
  action(FlyerDetailPageActions.FetchPagePreviewFailure, error);

export const createPagePosition = (templatePositionId: number) =>
  action(FlyerDetailPageActions.CreatePagePosition, templatePositionId);
export const createPagePositionSuccess = (pagePosition: IFlyerDetailPagePosition) =>
  action(FlyerDetailPageActions.CreatePagePositionSuccess, pagePosition);
export const createPagePositionFailure = (error: IError) =>
  action(FlyerDetailPageActions.CreatePagePositionFailure, error);

export const setEditPagePositionId = (pagePositionId: number) =>
  action(FlyerDetailPageActions.SetEditPagePositionId, pagePositionId);

export const fetchPageTemplate = (templateId: number) =>
  action(FlyerDetailPageActions.FetchPageTemplate, templateId);
export const fetchPageTemplateSuccess = (template: FlyerTemplate) =>
  action(FlyerDetailPageActions.FetchPageTemplateSuccess, template);
export const fetchPageTemplateFailure = (error: IError) =>
  action(FlyerDetailPageActions.FetchPageTemplateFailure, error);

export const selectLanguage = (language: Language) =>
  action(FlyerDetailPageActions.SelectLanguage, language);

export const setEditType = (type: FlyerDetailPageEditType) =>
  action(FlyerDetailPageActions.SetEditType, type);

export const deSelectPosition = () => action(FlyerDetailPageActions.DeSelectPosition);

export const updatePage = (changes: Partial<IFlyerDetailPage>) =>
  action(FlyerDetailPageActions.UpdatePage, changes);

export const resetEditType = () => action(FlyerDetailPageActions.ResetEditType);

export const reset = () => action(FlyerDetailPageActions.Reset);

export const initPermissions = (flyerPreview: FlyerDetailPagePreview) =>
  action(FlyerDetailPageActions.InitPermissions, flyerPreview);

export const navigateToFlyerPages = (flyerId: number) =>
  action(FlyerDetailPageActions.NavigateToFlyerPages, flyerId);

const actionCreators = {
  fetchPagePreview,
  fetchPagePreviewSuccess,
  fetchPagePreviewFailure,

  createPagePosition,
  createPagePositionSuccess,
  createPagePositionFailure,

  setEditPagePositionId,

  setEditType,
  deSelectPosition,
  updatePage,
  selectLanguage,

  fetchPageTemplate,
  fetchPageTemplateSuccess,
  fetchPageTemplateFailure,

  resetEditType,

  reset,
  navigateToFlyer: navigateToFlyerPages,

  initPermissions,
};

export type FlyerDetailPageActionType =
  | FlyerDetailPageAssetsActionType
  | FlyerDetailPageFormPositionActionType
  | FlyerDetailPageFormPageActionType
  | ActionType<typeof actionCreators>;
